import React from "react"
import DataTable from "../DataTable/DataTable"

class NotePopoverEdit extends React.Component {
  
  constructor(props) {
    super(props)
  };

  render() {
    return (
      <div className='active tab-pane' id="notes">
          <DataTable endpoint={this.props.reservation_segment_notes_path}
                     date_format={this.props.date_format} 
                     time_format={this.props.time_format} 
                     read_only={this.props.read_only} />
      </div>
    );
  };

};

export default NotePopoverEdit